module.exports = __webpack_public_path__ + "ba0b120fe013ca88a4da96fbbb2cda09.ttf";